// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel_base-module___wrapper___bb5feeca","carousel":"carousel_base-module___carousel___e080c336"};